





import { Component, Vue } from 'vue-property-decorator'
import { register } from 'register-service-worker'
import Env from '@finx/web-repository/src/services/Env'

@Component

export default class ViewUpdate extends Vue {
  mounted() {
    this.updateApp()
  }

  updateApp() {
    const serviceWorkerEnvEnable = Env.ENV === 'development'
    const serviceWorkerUrl = `${Env.CLIENT_ADDRESS}/service-worker.js`

    if (serviceWorkerEnvEnable) {
      register(serviceWorkerUrl, {
        // update() {}
      })
    }
  }
}
